import { compose } from "seneca-common/utils/functions/compose";

import { handleAuthentication } from "./actions/handleAuthentication";
import { CreditCardForm } from "./components/CreditCardForm";
import { withHandleCreditCardFormSubmit } from "./containers/withHandleCreditCardFormSubmit";
import { withHandleUpdatePaymentMethodFormSubmit } from "./containers/withHandleUpdatePaymentMethodFormSubmit";
import { withStripeElements } from "./containers/withStripeElements";
import { withSubmitErrorHandler } from "./containers/withSubmitErrorHandler";

const withCreateSubscription = compose(
  withStripeElements,
  // @ts-ignore
  withSubmitErrorHandler,
  withHandleCreditCardFormSubmit
);

const withUpdatePaymentDetails = compose(
  withStripeElements,
  // @ts-ignore
  withSubmitErrorHandler,
  withHandleUpdatePaymentMethodFormSubmit
);

export {
  // containers
  withStripeElements,
  withUpdatePaymentDetails,
  withCreateSubscription, // components
  CreditCardForm, // actions
  handleAuthentication
};
